import { useRef } from 'react';

export const useSwipe = ({onSwipeLeft, onSwipeRight}) => {
    const touchStart = useRef()
    const touchEnd = useRef()

    const minSwipeDistance = 50;

    const onTouchStart = (e) => {
        touchEnd.current = null;
        touchStart.current = e.targetTouches[0].clientX;
    }

    const onTouchMove = (e) => touchEnd.current = e.targetTouches[0].clientX;

    const onTouchEnd = () => {
        if (!touchStart.current || !touchEnd.current) return
        const distance = touchStart.current - touchEnd.current
        const isLeftSwipe = distance > minSwipeDistance
        const isRightSwipe = distance < -minSwipeDistance
        if (isLeftSwipe) {
            onSwipeLeft();
            return;
        }
        if (isRightSwipe) {
            onSwipeRight();
        }
    }

    return {
        onTouchStart,
        onTouchMove,
        onTouchEnd
    }
}
